export function splitBy<T>(array: T[], predicate: (d: T) => boolean): [T[], T[]] {
  return array.reduce<[T[], T[]]>(
    (accu, curr) => {
      const side = predicate(curr);
      accu[side ? 0 : 1].push(curr);

      return accu;
    },
    [[], []],
  );
}

export function splitWithMatches(text: string, regex: RegExp): string[] {
  const result = [text];

  while (result.at(-1) !== '') {
    const current = result.pop();
    if (!current) break;

    const match = current.match(regex);
    const matchStart = match?.index;

    if (match && matchStart !== undefined) {
      result.push(current.slice(0, matchStart));
      result.push(match[0]);
      result.push(current.slice(matchStart + match[0].length));
    } else {
      result.push(current);
      result.push('');
    }
  }

  return result.filter((part) => part !== '');
}
